// --- React
import React, { useMemo } from 'react';
// --- Utils
import { getProspectDetails } from '../utils/getDetailsData';
// --- Components
import { FieldRow } from '../../components';
// --- Styles
import '../../styles.scss';

/**
 * ProspectCard
 *
 * Features:
 * - Displays prospect details in tap-ui style (horizontal label-value)
 * - Supports search/filter functionality
 *
 * @param {object} details - Product details object
 * @param {string} searchTerm - Optional search term to filter fields
 * @returns {Element}
 */
export function ProspectCard({ details, searchTerm = '' }) {
    // Function to extract prospect details from the provided data
    const prospectDetails = useMemo(() => getProspectDetails(details), [details]);

    // Filter fields based on search term
    const filteredFields = useMemo(() => {
        if (!searchTerm.trim()) return prospectDetails;

        const term = searchTerm.toLowerCase();
        return prospectDetails.filter(
            (field) =>
                field.label.toLowerCase().includes(term) ||
                String(field.value || '').toLowerCase().includes(term)
        );
    }, [prospectDetails, searchTerm]);

    if (filteredFields.length === 0 && searchTerm.trim()) {
        return (
            <div className="no-results">
                <i className="fa-solid fa-search" />
                <p>No fields match your search.</p>
            </div>
        );
    }

    return (
        <div className="prospect-card">
            <div className="detail-section-content">
                {filteredFields.map(({ label, value }, idx) => (
                    <FieldRow
                        key={`prospect-${idx}`}
                        label={label}
                        value={value}
                        noBorder={idx === filteredFields.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}
